import { TIIndicatorPointToHighChartIndicatorPointMapper } from '../../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper';
import { TIIndicatorDataModel } from '../../models/data-point/ti-indicator-data.model';
import { IndicatorOptionModel } from '../../models/drop-down-list/indicator-option.model';
import { IComponent } from "../component.interface";
import { TiChartSeriesComponent } from '../ti-chart-series.component';

export class BBandsIndicatorComponent implements IComponent {
    public id = '';

    private tiChartSeries: TiChartSeriesComponent;

    constructor(tiChartSeries: TiChartSeriesComponent) {
        this.tiChartSeries = tiChartSeries;
    }

    public updateChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, tiIndicatorDataIndex: number, isUpdate: boolean) {
        const bbandBottomSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('BB_B') >= 0);
        const bbandBottom = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('BB_B') >= 0);
        const tiIndicatorBBBottomIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators.findIndex((x: TIIndicatorDataModel) => x.name.indexOf('BB_B') >= 0);
        if (!bbandBottom || !bbandBottomSeries || tiIndicatorBBBottomIndex <= - 1) {
            return;
        }

        const bbBottomIndicatorDataPoint = bbandBottom.points?.length ? bbandBottom.points[bbandBottom.points.length - 1] : null;
        if (!bbBottomIndicatorDataPoint) {
            return;
        }

        const needZone = bbandBottom.needHighChartZone(bbandBottomSeries.type);
        if (isUpdate) {
            const lastChartBar = bbandBottomSeries.points.find((x: any) => x.x == bbBottomIndicatorDataPoint.xValue);
            const tiIndicatorDataPointIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].points.findIndex(x => x.xValue == bbBottomIndicatorDataPoint.xValue);
            // update to main ti indicator data points
            if (tiIndicatorDataPointIndex > -1) {
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].points[tiIndicatorDataPointIndex] = bbBottomIndicatorDataPoint;
            }

            if (!lastChartBar) {
                const dataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex], indicatorOption.value, true);
                bbandBottomSeries.setData(dataPoints.points, true, false, true);
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones = dataPoints.zones;
            } else {
                const lastHighChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, bbBottomIndicatorDataPoint, bbandBottom);
                lastChartBar.update(lastHighChartDataPoint, false);

                if (needZone) {
                    const existingZoneIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].zones.findIndex((x: any) => x.value == bbBottomIndicatorDataPoint.xValue);
                    if (existingZoneIndex > -1) {
                        const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(bbBottomIndicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                        this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones[existingZoneIndex] = lastHighChartZoneDataPoint;
                    }
                }
            }
        } else {
            const highChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, bbBottomIndicatorDataPoint, bbandBottom);
            bbandBottomSeries.addPoint(highChartDataPoint, false);
            this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].points.push(bbBottomIndicatorDataPoint);
            if (needZone) {
                const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(bbBottomIndicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones.push(lastHighChartZoneDataPoint);
            }
        }

        if (needZone) {
            bbandBottomSeries.update({
                zones: this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones,
                type: bbandBottomSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            });
        }
    }
    
    public updateHistoryChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, firstPoint: number) {
        const bbandBottomSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('BB_B') >= 0);
        const bbandBottom = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('BB_B') >= 0);
        if (!bbandBottom || !bbandBottomSeries) {
            return;
        }

        const needZone = bbandBottom.needHighChartZone(bbandBottomSeries.type);
        for (let j = bbandBottom.points.length - 1; j > 0; j--) {
            const indicatorDataPoint = bbandBottom.points[j];
            if (indicatorDataPoint.timestamp && indicatorDataPoint.xValue < firstPoint) {
                const point = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, indicatorDataPoint, bbandBottom);
                bbandBottomSeries.addPoint(point, false);
                if (needZone) {
                    const zonePoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(indicatorDataPoint, indicatorData);
                    bbandBottom.zones.unshift(zonePoint);
                }
            }
        }
        if (needZone) {
            bbandBottomSeries?.update({
                zones: bbandBottom.zones,
                type: bbandBottomSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            }, false);
        }
    }
}